import React, { Component } from "react";
// import AirplaneSVG from "../AirplaneSVG";
import MediaQuery from "../../components/MediaQuery";
import styled from "styled-components";
// import { css } from "styled-components";

import "./styles.css";

// Styles
const md = "14px";
const sm = "12px";
const desktopCss = MediaQuery.desktop`
  font-size: ${md};
`;

const Duration = styled.div`
  color: red;
  font-size: ${sm};
  text-align: right;
  font-weight: 600;
  flex: 0.2;
  min-width: 49px; // to prevent word-wrap in small mobile view
  ${desktopCss};
`;
const Layover = Duration.extend`
  margin: 10px 0;
`;
const LayoverNote = styled.span`
  text-align: center;
  background-color: rgb(251, 232, 204);
  color: rgb(160, 93, 0);
  display: block;
  padding: 5px;
  border-radius: 2px;
  margin-right: 3px;
  margin-bottom: 5px;
`;

const TimeCityAirportTable = styled.div`
  display: flex;
`;
const GreyText = styled.div`
  font-size: ${sm};
  color: #9a9a9a;
  font-weight: 300;

  ${desktopCss};
`;
const AirlineImageWrapper = styled.div`
  text-align: left;
  display: flex;
  margin-bottom: 15px;
`;

const AirlineImage = styled.img`
  width: 47px;
  height: 47px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
`;

const BoldDarkMedFont = styled.div`
  font-weight: 400;
  font-size: ${sm};
  font-weight: 600;

  ${desktopCss};
`;

// Components
const TimeCityAirportColumn = ({ time, city, state, airport, iata }) => {
  // Styles
  const Wrapper = styled.div`
    flex: 0.8;
  `;
  const Time = styled.div`
    font-weight: 600;
  `;
  // const City = styled.div`
  //   font-weight: 400;
  //   font-size: ${sm};
  //   font-weight: 600;

  //   ${desktopFontSize};
  // `;
  const Airport = styled.div`
    font-size: ${sm};
    color: #9a9a9a;
    font-weight: 300;

    ${desktopCss};
  `;

  return (
    <Wrapper>
      <Time>{time}</Time>
      <BoldDarkMedFont>
        {city}, {state}
      </BoldDarkMedFont>
      <Airport>
        {" "}
        {iata} - {airport}{" "}
      </Airport>
    </Wrapper>
  );
};

const Dot = styled.div`
  content: "";
  border-radius: 100%;
  width: 4px;
  height: 4px;
  margin: auto 4px;
  background-color: #687b8e;
  vertical-align: middle;
  display: inline-block;
`;

class TripSegment extends Component {
  render() {
    let {
      aircraft,
      aircraftType,
      carrierName,
      flightNumber,
      carrierImageUrl,
      origin,
      destination,
      arrivalTime,
      // arrivalDay,
      departureTime,
      // departureDay,
      flightDuration,
      operatingAirlineName,
      cabin,
      layoverNoteValues,
      layoverDuration,
      totalTripDuration,
      originAirportName,
      originAirportCity,
      originAirportState,
      originAirportCountry,
      destinationAirportCity,
      destinationAirportState,
      destinationAirportCountry,
      destinationAirportName
    } = this.props.tripSegment;
    let isLayoverDurationPresent = !!layoverDuration;

    return (
      // <div style={{display: 'flex'}}>
      <div>
        <AirlineImageWrapper>
          <AirlineImage alt="airline logo" src={carrierImageUrl} />
          <div>
            <GreyText>
              {" "}
              {carrierName} <Dot /> {flightNumber && `Flight ${flightNumber}`}{" "}
            </GreyText>
            <GreyText>
              {aircraft} <Dot /> {aircraftType}
            </GreyText>
            <GreyText>
              {operatingAirlineName && `Operated by ${operatingAirlineName}`}
            </GreyText>
            <BoldDarkMedFont>{cabin}</BoldDarkMedFont>
          </div>
        </AirlineImageWrapper>

        <TimeCityAirportTable>
          <TimeCityAirportColumn
            time={departureTime}
            city={originAirportCity}
            state={
              originAirportState ? originAirportState : originAirportCountry
            } // For international flights, PPN doesn't provide states. So we use the country in place of states
            airport={originAirportName}
            iata={origin}
          />
          <TimeCityAirportColumn
            time={arrivalTime}
            city={destinationAirportCity}
            state={
              destinationAirportState
                ? destinationAirportState
                : destinationAirportCountry
            } // For international flights, PPN doesn't provide states. So we use the country in place of states
            airport={destinationAirportName}
            iata={destination}
          />
          <Duration>{flightDuration}</Duration>
        </TimeCityAirportTable>

        <Layover>
          {layoverNoteValues && (
            <React.Fragment>
              {layoverNoteValues.map(layoverNoteValue => (
                <LayoverNote> {layoverNoteValue} </LayoverNote>
              ))}
            </React.Fragment>
          )}
          {isLayoverDurationPresent ? (
            <span> Layover: {layoverDuration} </span>
          ) : (
            <span> Total Trip: {totalTripDuration} </span>
          )}
        </Layover>
      </div>
    );
  }
}

export default TripSegment;



// WEBPACK FOOTER //
// ./src/components/TripSegment/index.js